// extracted by mini-css-extract-plugin
export var activeDot = "_6w-c";
export var buttonContainer = "_6w-9";
export var channelButton = "_6w-a";
export var clickable = "_6w-d";
export var content = "_6w-0";
export var contentFull = "_6w-2";
export var contentThird = "_6w-1";
export var contentWrapper = "_6w-7";
export var description = "_6w-5";
export var heightShort = "_6w-f";
export var image = "_6w-3";
export var imageContainer = "_6w-4";
export var selectButton = "_6w-e";
export var spinnerContainer = "_6w-b";
export var titleContent = "_6w-8";
export var titleWrapper = "_6w-6";